import { render, staticRenderFns } from "./PaymentGopay.vue?vue&type=template&id=0f5ff718"
import script from "./PaymentGopay.vue?vue&type=script&lang=js"
export * from "./PaymentGopay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports